import { openFinalPanelAfterPostFx } from "../../../shared/lib/effects/openFinalPanelAfterPostFx/openFinalPanelAfterPostFx"
import { postVotesFx } from "../lib/effects/postVotesFx/postVotesFx"
import { createEffect, createEvent, createStore, sample } from "effector"
import { createGate } from "effector-react"
import { messagesTypes, setMessage } from "src/entity/Messages"
import { $firstStageVotes, PostVoteT } from "src/entity/Pretendents"
import { resetFirstStageVotes } from "src/entity/Pretendents/model/Pretendents"
import { $userHash, $userId } from "src/entity/User"

export const PostVotesGate = createGate()

const setIsPosting = createEvent<boolean>()
export const $isPosting = createStore<boolean>(false)

export const postVotes = createEvent()

const scrollToMessageFx = createEffect(() => {
  window.parent.postMessage(
    {
      type: "scrollToModal",
      modalClass: "iframe",
    },
    "*"
  )
})
const fireConfettiFx = createEffect(() => {
  window.parent.postMessage(
    {
      type: "confettiFire",
    },
    "*"
  )
})

sample({
  clock: setIsPosting,
  target: $isPosting,
})

sample({
  clock: postVotes,
  source: $firstStageVotes,
  filter: ($firstStageVotes) => !Object.keys($firstStageVotes).length,
  fn: () => messagesTypes.FILL_ERROR,
  // fn: () => messagesTypes.SET_CONGRAT_FORM,
  target: setMessage,
})

sample({
  clock: postVotes,
  source: { $firstStageVotes, $userId, $userHash },
  filter: ({ $firstStageVotes }) => !!Object.keys($firstStageVotes).length,
  fn: ({ $firstStageVotes, $userId, $userHash }): any => ({
    votes: { ...$firstStageVotes },
    vkId: String($userId),
    userHash: $userHash,
  }),
  target: postVotesFx,
})

sample({
  clock: postVotesFx.failData,
  fn: () => messagesTypes.POST_ERROR,
  target: setMessage,
})

sample({
  clock: postVotesFx.pending,
  fn: () => true,
  target: setIsPosting,
})

sample({
  clock: [postVotesFx.done, postVotesFx.fail],
  fn: () => false,
  target: setIsPosting,
})

// sample({
//   clock: postVotesFx.doneData,
//   target: openFinalPanelAfterPostFx
// });

sample({
  clock: postVotesFx.doneData,
  fn: () => messagesTypes.SET_CONGRAT_FORM,
  target: setMessage,
})

sample({
  clock: postVotesFx.doneData,
  target: resetFirstStageVotes,
})

sample({
  clock: postVotesFx.doneData,
  target: fireConfettiFx,
})

sample({
  clock: setMessage,
  target: scrollToMessageFx,
})
